
import React, {Component} from 'react';
import Iframe from '../../components/iframe/iframe';
import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  width: 100%;

height:100%;
  justify-content: flex-start;
  align-items:stretch;
  align-self:center;



`;

    class Plasticpollution extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: 'https://resourcewatch.org/embed/data/explore/Wat063-Plastic-Input-in-Rivers?section=Discover&zoom=0.9321208865543066&lat=10.952937308788085&lng=-67.49309449121667&pitch=0&bearing=0&basemap=dark&labels=light&layers=%255B%257B%2522dataset%2522%253A%252238e1bdc7-a843-40b8-ac86-2e47ccd896e4%2522%252C%2522opacity%2522%253A1%252C%2522layer%2522%253A%25228ad07c40-dbb6-4703-8146-a36b9f441dd2%2522%257D%255D&page=1&sort=most-viewed&sortDirection=-1'
        };
    }

    render() {
        return (
            <Center>
                <Iframe source={this.state.src} />
            </Center>
        );
    }
}

export default Plasticpollution;